import { GridColDef } from "@mui/x-data-grid";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { useMemo } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  distribuicaoSelecionada: any;
  dropdownEpis: any[];
};

export const VisualizarItensModal = ({
  open,
  onClose,
  distribuicaoSelecionada,
  dropdownEpis,
}: Props) => {
  const itensMapeados = useMemo(() => {
    if (!distribuicaoSelecionada || !distribuicaoSelecionada.itens) return [];

    return distribuicaoSelecionada.itens.map((item: any, index: number) => {
      const epiData = dropdownEpis?.find(
        (x) => x.idGestaoRecebimentoEpi === item.idGestaoRecebimentoEpi,
      );
      const nomeCompleto = epiData?.nomeEpi || "EPI não encontrado";
      const nomeLimpo = nomeCompleto.includes("-")
        ? nomeCompleto.split("-")[0].trim()
        : nomeCompleto;

      const tipo = nomeCompleto.includes("-")
        ? nomeCompleto.split("-")[1].trim()
        : nomeCompleto;

      return {
        id: index,
        nomeEpi: nomeLimpo,
        especificacao: tipo,
        ca: epiData?.ca || "-",
        quantidade: item.quantidade,
      };
    });
  }, [distribuicaoSelecionada, dropdownEpis]);

  const columns: GridColDef[] = [
    {
      field: "nomeEpi",
      headerName: "Nome do EPI",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "especificacao",
      headerName: "Tipo / Numeração",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "ca",
      headerName: "Certificado de Aprovação",
      width: 180,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },

    {
      field: "quantidade",
      headerName: "Quantidade",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
  ];

  return (
    <BaseFormControlledModal
      open={open}
      title={`EPIs Entregues para ${distribuicaoSelecionada?.funcionario || ""}`}
      width="800px"
      onClose={onClose}
      onSubmit={onClose}
      saving={false}
      loading={false}
    >
      <div className="w-full mt-4 h-[350px]">
        <StyledDataGrid
          tableName="epis_entregues"
          rows={itensMapeados}
          columns={columns}
          getRowId={(row: any) => row.id}
          disableRowSelectionOnClick
          hideFooter
          getRowHeight={() => "auto"}
          textSize="medio"
          autoHeight={true}
        />
      </div>
    </BaseFormControlledModal>
  );
};
